<template>
    <div>
        <v-autocomplete
            ref="facility"
            v-model.trim="facility"
            clearable
            color="teal"
            label="Name of Hospital/Clinic"
            :items="getToHospClin"
            :rules="[v => !!v || 'This field is required']"
            item-text="hosp_name"
            return-object
            auto-select-first
            autocomplete="nope"
            :loading="loading.main || loading.to.hospital"
            :disabled="loading.main || loading.to.hospital"
            @click:clear="handleClearHospName"
            @change="handleChangeHospName($event)"
        />
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
    props: ['to', 'member_model', 'loading'],
    data: ()=>({
        facility: null
    }),
    computed: {
        ...mapGetters(['getToHospClin'])
    },
    watch: {
        getToHospClin() {
            this.loading.to.hospital = false
        },
        'to.facility'(newVal) {
            this.facility = newVal
        }
    },
    methods: {
        ...mapActions(['toProvinces', 'toCities', 'toHospClin', 'toDoctors']),
        handleChangeHospName(value) {
            this.to.facility = value
            if (value) {
                this.to.hospClinDoctor = ''
                this.to.hospClinDoctorCode = null
                this.to.region = String(value.hosp_region).trim()
                this.to.province = String(value.city_province).trim()
                this.to.city = String(value.city_name).trim()
            } else {
                this.to.filter.doc = false
                if (this.to.specField)
                    this.to.specField = { sp_name: 'ALL', sp_desc: '' }
            }
            this.to.hint.doc = false
            this.loading.to.province = true
            this.toProvinces({ REGION: this.to.region })
            this.loading.to.city = true
            this.toCities({ REGION: this.to.region, PROVINCE: this.to.province })
            if (this.to.filter.hosp) {
                this.loading.to.hospital = true
                this.toHospClin({ REGION: this.to.region ? this.to.region : '', PROVINCE: this.to.province ? this.to.province : '', CITY: this.to.city ? this.to.city : '', TYPE: '', MEMBN: this.member_model.MEMB_N })
            }
            this.loading.to.doctor = true
            this.toDoctors({ PTYPE: '', HOSP_MSU: value && value.hosp_msu_code, SPEC: this.to.specField && this.to.specField.sp_desc })
            this.to.hospClinType = value && value.hosp_ptype
            this.to.decking = value && value.hosp_decking
        },
        handleClearHospName() {
            this.to.region = ''
            this.to.province = ''
            this.to.city = ''
        }
    }
}
</script>
